module.exports =
  countries: (Api) ->
    return Api.Country.query().$promise

  subject: ->
